const accentShades = {
  blue: '#C9D9EE',
  purple: '#E6E2F2',
  coral: '#FFA290',
};

const blueShades = {
  100: '#F9FEFF',
  150: '#CFE6F0',
  200: '#CAD6E3',
  300: '#21BCE4',
  400: '#1994B3',
  500: '#51697E',
  600: '#364B5E',
  700: '#1C3042',
  800: '#001F28',
  900: '#00131A',
};

const creamShades = {
  10: '#FFFEFB',
  25: '#FCF7F0', // Neutral container
  50: '#FFEDDA',
  100: '#FCD2A7',
  200: '#F7B470',
  300: '#F1963B',
  400: '#EE800F',
  500: '#E86C00',
  600: '#E56000',
  700: '#DE4F00',
  800: '#D73C00',
  900: '#CD0E04',
};

const greenShades = {
  100: '#D2EFE7', // Success container
  150: '#D2EFD4',
  200: '#B7E6BA',
  300: '#68CA6C',
  400: '#26AB76',
  500: '#1E5720',
  600: '#133415',
};

const greyShades = {
  100: '#FFFFFF',
  200: '#FBFCFE',
  225: '#EFF1F2',
  250: '#DCE4E8',
  300: '#A9ABAD',
  400: '#70787C',
  500: '#505354',
  600: '#40484B',
  700: '#232628',
  800: '#191C1D',
  900: '#000000',
};

const navyShades = {
  50: '#E3E8EC', // Neutral Accent
  75: '#D2DAE3',
  100: '#B9C4D1',
  200: '#8C9FB2',
  300: '#627A94',
  400: '#405F80',
  500: '#364B5E',
  600: '#0E4067',
  700: '#03375C',
  800: '#002E50',
  900: '#021E38',
};

const peachShades = {
  50: '#FBE7E7',
  100: '#FFC7BB',
  200: '#FFA290',
  300: '#FF7C65',
  400: '#FF5C45',
  500: '#FF3A28',
  600: '#F43424',
  700: '#E62D1F',
  800: '#D7251B',
  900: '#BE1512',
};

const redShades = {
  100: '#FFEDEA',
  200: '#FFC7BB', // Error container
  300: '#FF5449',
  400: '#CD0E04',
  500: '#93000A',
  600: '#690005',
  700: '#410002',
};

const secondaryShades = {
  100: '#F9FEFF',
  200: '#CFE6F0',
  300: '#B5EBFF',
  400: '#21BCE4',
  500: '#1994B3',
};

const tealShades = {
  50: '#E0F3F1',
  100: '#B3E0DA',
  200: '#81CDC3',
  300: '#4FB9AB',
  400: '#2BA999',
  500: '#0F9987',
  600: '#0D8C7A',
  700: '#0A7C6A',
  800: '#076C5B',
  900: '#045040',
};

const yellowShades = {
  100: '#FFFBF5',
  200: '#F9DDB5', // Warning container
  300: '#FFBC57',
  400: '#DC7F3B',
  500: '#804600',
  600: '#3D2100',
};

export const lightModeShades = {
  accent: accentShades,
  blue: blueShades,
  cream: creamShades,
  green: greenShades,
  grey: greyShades,
  navy: navyShades,
  peach: peachShades,
  red: redShades,
  secondary: secondaryShades,
  teal: tealShades,
  yellow: yellowShades,
};
